import React from 'react'
import { Box, Grid, makeStyles, Typography, Hidden, Avatar } from '@material-ui/core'
import Cards from './cards'
import Data from "../../data/data"
const useStyles = makeStyles((theme) => ({

    box1: {
        paddingTop: "120px",
        width: "100%",
        backgroundColor: "#15244D"
    },
}));
function States() {
    const classes = useStyles();
    return (
        <Box  className={classes.box1} width={1} >
            <Box maxWidth="1248px" mx="auto" style={{ backgroundColor: "#15244D" }} p="10px">
                {Data ? <Cards states={Data} /> : <div style={{ color: "white" }}> "Loading......................."</div>}
            </Box>
        </Box>
    )
}

export default States
